import React from 'react';
import { XIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { painPoints } from '../../data/salesContent';
export function PainSection() {
  return <section className="bg-ink px-5 py-20 md:py-28" data-id="element-136" data-mp="2riswj572wvip">
      <div className="mx-auto max-w-3xl" data-id="element-137" data-mp="2rh7zn8xal0ho">
        <SectionHeading title="¿Te pasa esto antes de dar una clase?" data-id="element-138" data-mp="2mk80zj2rv00l" />
        <ul className="mt-12 divide-y divide-ink-line border-y border-ink-line" data-id="element-139" data-mp="2mmc5a24l211e">
          {painPoints.map(p => <li key={p} className="flex items-start gap-4 py-5 text-lg leading-relaxed text-neutral-200 md:text-xl" data-id="element-140" data-mp="2cuesiqxxf10k">
              <span className="mt-1 flex h-6 w-6 shrink-0 items-center justify-center rounded-full border border-gold/50" data-id="element-141" data-mp="28rrwedu82txk">
                <XIcon className="h-3.5 w-3.5 text-gold" aria-hidden="true" data-id="element-142" data-mp="23urnzw9whf3a" />
              </span>
              {p}
            </li>)}
        </ul>
        <div className="mt-12 text-center" data-id="element-143" data-mp="1tvke5j2dk2kx">
          <p className="text-lg text-neutral-400 md:text-xl" data-id="element-144" data-mp="1twlsbweot56v">Y cuando terminás una capacitación...</p>
          <p className="mt-3 font-display text-2xl font-black uppercase leading-tight text-cream md:text-3xl" data-id="element-145" data-mp="19r7s4rqqmat7">
            En la siguiente volvés a preparar <span className="text-gold" data-id="element-146" data-mp="zumitu7oqdjk">gran parte de todo otra vez.</span>
          </p>
        </div>
      </div>
    </section>;
}